var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 72,
    viewBox: "0 0 117 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.062 7.70001H42.562V64.31H74.062V7.70001Z",
    fill: "#F26522"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.562 36C44.562 24.52 49.942 14.29 58.312 7.7C52.192 2.88 44.462 0 36.062 0C16.182 0 0.0620117 16.12 0.0620117 36C0.0620117 55.88 16.182 72 36.062 72C44.462 72 52.182 69.12 58.312 64.3C49.942 57.71 44.562 47.48 44.562 36Z",
    fill: "#E51B24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.562 36C116.562 55.88 100.442 72 80.562 72C72.162 72 64.442 69.12 58.312 64.3C66.682 57.71 72.062 47.48 72.062 36C72.062 24.52 66.682 14.29 58.312 7.7C64.432 2.88 72.162 0 80.562 0C100.442 0 116.562 16.12 116.562 36Z",
    fill: "#F99F1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.122 58.31V57.15H113.592V56.91H112.402V57.15H112.872V58.31H113.122ZM115.432 58.31V56.91H115.072L114.652 57.87L114.232 56.91H113.862V58.31H114.122V57.26L114.512 58.17H114.782L115.172 57.26V58.32H115.432V58.31Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcLogoColor);
export default __webpack_public_path__ + "static/media/mc-logo-color.3ada44950df5f1e80e83d6d15eec6486.svg";
export { ForwardRef as ReactComponent };